<template>
  <el-row>
    <el-col :span="24">
      <el-card class="box-card">
        <div slot="header" class="flex justify-between">
          <span>{{viewOrgInfo.componentName}}</span>
          <div style="float: right;">
            <el-button 
              v-if="viewOrgInfo.index != 2" 
              type="primary" 
              size="small"
              @click="_openSelectOrgInfoModel()"
            >
              <i class="el-icon-search"></i> {{viewOrgInfo.buttonName}}
            </el-button>
          </div>
        </div>
        <div class="text item">
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="form-group">
                <label class="el-form-item__label">组织名称：</label>
                <label>{{viewOrgInfo.orgName}}</label>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-group">
                <label class="el-form-item__label">组织级别：</label>
                <label>{{viewOrgInfo.orgLevelName}}</label>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-group">
                <label class="el-form-item__label">上级组织：</label>
                <label>{{viewOrgInfo.parentOrgName}}</label>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="form-group">
                <label class="el-form-item__label">组织ID：</label>
                <label>{{viewOrgInfo.orgId}}</label>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-group">
                <label class="el-form-item__label">描述：</label>
                <label>{{viewOrgInfo.description}}</label>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </el-col>
    <choose-org 
      ref="chooseOrg"
      :emitChooseOrg="'viewOrgInfo'"
      :emitLoadData="'viewOrgInfo'"
    ></choose-org>
  </el-row>
</template>

<script>
import ChooseOrg from '@/components/frame/chooseOrg/chooseOrg.vue'

export default {
  name: 'ViewOrgInfo',
  components: {
    ChooseOrg
  },
  props: {
    callBackListener: String,
    callBackFunction: String
  },
  data() {
    return {
      viewOrgInfo: {
        componentName: '组织管理信息',
        buttonName: '选择组织',
        index: 0,
        flowComponent: 'viewOrgInfo',
        orgId: '',
        orgName: '',
        orgLevel: '',
        orgLevelName: '',
        parentOrgId: '',
        parentOrgName: '',
        description: '',
        branchOrgId: '',
      }
    }
  },
  methods: {
    _openSelectOrgInfoModel() {
      this.$refs.chooseOrg.open({
        orgLevel: this.viewOrgInfo.orgLevel,
        parentOrgId: this.viewOrgInfo.parentOrgId
      })
    },
    updateIndex(index) {
      this.viewOrgInfo.index = index
    },
    initInfo(info) {
      Object.assign(this.viewOrgInfo, info)
    }
  },
  created() {
    this.$on('viewOrgInfo', 'chooseOrg', (org) => {
      Object.assign(this.viewOrgInfo, org)
      this.$emit(this.callBackFunction, this.viewOrgInfo)
    })
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 20px;
}
.el-form-item__label {
  font-weight: bold;
}
</style>